import { RESULT, RESULTS } from '../constants/savedSearches.constants';

export const getResultsWording = (count) => {
  return count % 10 === 1 ? `${count} ${RESULT}` : `${count} ${RESULTS}`;
};
